import { createDashboardFiltersController } from './dashboard/filters-controller.js';
import { createDashboardOrderController } from './dashboard/order-controller.js';
import { createSectionMap } from './dashboard/section-map.js';
import { createDashboardSectionsController } from './dashboard/sections-controller.js';

(function () {
    const sectionsContainer = document.querySelector('[data-dashboard-sections]');
    if (!(sectionsContainer instanceof HTMLElement)) {
        return;
    }

    const sectionElements = Array.from(sectionsContainer.querySelectorAll('[data-status]'));
    if (sectionElements.length === 0) {
        return;
    }

    const sectionMap = createSectionMap(sectionElements);
    const defaultOrder = Array.from(sectionMap.keys());
    if (defaultOrder.length === 0) {
        return;
    }

    // No initial reordering: sections are rendered in the stored order already.
    createDashboardOrderController({
        sectionsContainer,
        sectionMap,
    }).initializeModal();

    const filtersController = createDashboardFiltersController({
        sectionsContainer,
        sectionMap,
        defaultOrder,
    });
    const sectionsController = createDashboardSectionsController({
        sectionsContainer,
        sectionMap,
        restoreFiltersFromUrl: filtersController.restoreFromUrl,
    });
    sectionsController.initialize();
    filtersController.initialize();
})();
